"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _withMobileDialog = _interopRequireDefault(require("@material-ui/core/withMobileDialog"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

///require("../../assets/css/logo-alt.png")
var Modal = function Modal(_ref) {
  var classes = _ref.classes,
      logoUrl = _ref.logoUrl,
      preTitle = _ref.preTitle,
      title = _ref.title,
      subTitle = _ref.subTitle,
      body = _ref.body,
      onClose = _ref.onClose,
      _ref$submitting = _ref.submitting,
      submitting = _ref$submitting === void 0 ? false : _ref$submitting,
      fullScreen = _ref.fullScreen,
      _ref$opened = _ref.opened,
      opened = _ref$opened === void 0 ? false : _ref$opened,
      _ref$saveButton = _ref.saveButton,
      saveButton = _ref$saveButton === void 0 ? {
    text: "Save",
    onClick: console.log,
    ButtonProps: {}
  } : _ref$saveButton,
      _ref$secondaryButton = _ref.secondaryButton,
      secondaryButton = _ref$secondaryButton === void 0 ? null : _ref$secondaryButton;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    className: classes.modal,
    fullScreen: fullScreen,
    open: opened,
    onClose: onClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, !!logoUrl && /*#__PURE__*/_react["default"].createElement("div", {
    className: "logoWrapper"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: logoUrl,
    alt: "logo"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "closeWrapper"
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), (!!title || !!subTitle) && /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    disableTypography: true
  }, !!preTitle && preTitle, !!title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "titleWrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h4"
  }, title)), !!subTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "subTitleWrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "caption",
    component: "h4"
  }, subTitle))), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, typeof body === 'string' ? /*#__PURE__*/_react["default"].createElement(_DialogContentText["default"], null, body) : body), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, submitting ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "indicator"
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    className: classes.progress,
    color: "secondary"
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !!saveButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    disabled: saveButton.disabled,
    variant: (saveButton.ButtonProps || {}).variant || 'contained',
    color: (saveButton.ButtonProps || {}).color || 'secondary',
    size: (saveButton.ButtonProps || {}).size || 'large',
    onClick: function onClick(evt) {
      return [evt.stopPropagation(), evt.preventDefault(), saveButton.onClick()];
    }
  }, saveButton.ButtonProps || {}), saveButton.text), !!secondaryButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    disabled: secondaryButton.disabled,
    variant: (secondaryButton.ButtonProps || {}).variant || 'text',
    color: (secondaryButton.ButtonProps || {}).color || 'default',
    size: (secondaryButton.ButtonProps || {}).size || 'large',
    onClick: function onClick(evt) {
      return [evt.stopPropagation(), evt.preventDefault(), secondaryButton.onClick()];
    }
  }, secondaryButton.ButtonProps || {}), secondaryButton.text))));
};

var _default = (0, _withMobileDialog["default"])()(Modal);

exports["default"] = _default;